module.exports = __webpack_public_path__ + "static/img/2_05.0f0c2942.jpg";